import React, {useEffect, useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {useDispatch, useSelector} from "react-redux";
import Drawer from '@material-ui/core/Drawer';
import Button from '@material-ui/core/Button';
import Collapse from '@material-ui/core/Collapse';
import Language from "../../atomic/PageHeader/Language";
import {Link} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {Hidden} from "@material-ui/core";
import {
    APP,
    LOGIN,
    MOBILE_LOGIN_SHORT,
    USER_EDIT_PROFILE,
    USER_UPDATE_PASSWORD,
    NETWORK_ROOM_AND_RATES
} from "../../../constants/appUrls.constants";
import {logout, clearState} from "../../../redux/actions/userActions";
import {isDefined, userLogout, getUserName, getProperty, getPropertyName} from "../../../utils";
import {history} from "../../../utils/history";
import {propertyProducts} from "../../../redux/actions/propertyProductsActions";
import Charts from "../../templates/Global/Charts";

const useStyles = makeStyles(theme => ({
    drawerPadding: {
        padding: "22px 8px",
        [theme.breakpoints.down('sm')]: {
            padding: '0',
        },
    },
}));

// "Cem Arslan" -> "CA"
const getInitials = (fullName) => {
    if (!fullName) return '?';
    const parts = String(fullName).trim().split(/\s+/).filter(Boolean);
    if (parts.length === 0) return '?';
    return parts
        .slice(0, 2)
        .map(part => part.charAt(0).toLocaleUpperCase('tr'))
        .join('');
};

export default function TemporaryDrawer() {
    const classes = useStyles();

    const { t } = useTranslation();
    const userReducer = useSelector(props => props.userReducer);
    const dispatch = useDispatch();

    const currentPath = window.location.pathname;
    const splitUrl = currentPath.split('/');

    const userName = getUserName();
    const propertyId = getProperty();
    const propertyName = getPropertyName();

    // Tesis secim ekraninda aktif bir tesis yok. localStorage son secilen tesisi
    // hatirlamaya devam ediyor (uygulama genelinde bilerek boyle), ama burada
    // tesise ozel bolumleri gostermek yaniltici: cikilan tesisin adi gorunuyor ve
    // "Oda ve Fiyat" linkleri kullaniciyi o tesise geri sokuyordu.
    const isPropertySelectScreen = currentPath === APP;

    const [open, setOpen] = useState(false);
    const [languageOpen, setLanguageOpen] = useState(false);
    // Oda & fiyat sayfalarındayken bölüm açık başlasın
    const [menuOpen, setMenuOpen] = useState(() => currentPath.indexOf(NETWORK_ROOM_AND_RATES) === 0);

    const openDrawer = () => setOpen(true);
    const closeDrawer = () => setOpen(false);

    useEffect(() => {
        if (splitUrl.length > 3) {
            dispatch(propertyProducts())
        }
    }, []);

    useEffect( () => {
        if(userReducer && !userReducer.fetching && userReducer.userLogoutStatus === 200){
            dispatch(clearState());
            userLogout();
            if (isDefined(localStorage.getItem("mobile_login"))) {
                history.push(MOBILE_LOGIN_SHORT + localStorage.getItem("mobile_login"));
            } else {
                history.push(LOGIN);
            }
        }
    },[userReducer]);

    const onClickLogout = () => {
        closeDrawer();
        dispatch(logout());
    };

    const isActive = (path) => currentPath === path;

    return (
        <div className={classes.drawerPadding}>
            <Button className="app-drawer-trigger" onClick={openDrawer} aria-label="menu">
                <Hidden xsDown>
                    <i className="fas fa-bars" />
                </Hidden>
                <Hidden smUp>
                    <i className="fas fa-bars gray" />
                </Hidden>
            </Button>

            <Drawer
                anchor="right"
                open={open}
                onClose={closeDrawer}
                classes={{ paper: 'app-drawer__paper' }}
            >
                <div className="app-drawer">

                    {/* Başlık */}
                    <div className="app-drawer__header">
                        <div className="app-drawer__avatar">{getInitials(userName)}</div>
                        <div className="app-drawer__identity">
                            <p className="app-drawer__greeting">{ t('enw-drawer_menu-title') }</p>
                            <p className="app-drawer__name">{userName}</p>
                        </div>
                        <button
                            type="button"
                            className="app-drawer__close"
                            onClick={closeDrawer}
                            aria-label={ t('btn-close') }
                        >
                            <i className="fal fa-times" />
                        </button>
                    </div>

                    {/* Aktif tesis */}
                    {!isPropertySelectScreen && isDefined(propertyId) && (
                        <div className="app-drawer__property">
                            <i className="fas fa-hotel" />
                            <div className="app-drawer__property-text">
                                {isDefined(propertyName) && (
                                    <span className="app-drawer__property-name">{propertyName}</span>
                                )}
                                <span className="app-drawer__property-id">
                                    <span className="app-drawer__property-id-label">
                                        { t('enw-drawer_menu-property_id') }:
                                    </span>
                                    <span className="app-drawer__property-id-value">{propertyId}</span>
                                </span>
                            </div>
                        </div>
                    )}

                    {/* Gezinme */}
                    <nav className="app-drawer__nav">
                        <Link
                            to={USER_EDIT_PROFILE}
                            onClick={closeDrawer}
                            className={`app-drawer__item${isActive(USER_EDIT_PROFILE) ? ' is-active' : ''}`}
                        >
                            <i className="fal fa-user" />
                            <span className="app-drawer__item-label">{ t('btn-edit_profile') }</span>
                        </Link>

                        <Link
                            to={USER_UPDATE_PASSWORD}
                            onClick={closeDrawer}
                            className={`app-drawer__item${isActive(USER_UPDATE_PASSWORD) ? ' is-active' : ''}`}
                        >
                            <i className="fal fa-lock-alt" />
                            <span className="app-drawer__item-label">{ t('btn-update_password') }</span>
                        </Link>

                        {/* Oda ve Fiyat — tesise ozel, secim ekraninda gizli */}
                        {!isPropertySelectScreen && <>
                        <button
                            type="button"
                            className="app-drawer__item"
                            onClick={() => setMenuOpen(!menuOpen)}
                            aria-expanded={menuOpen}
                        >
                            <i className="fal fa-bed" />
                            <span className="app-drawer__item-label">{ t('enw-room_and_rate-title') }</span>
                            <i className={`fas fa-chevron-down app-drawer__chevron${menuOpen ? ' is-open' : ''}`} />
                        </button>
                        <Collapse in={menuOpen} timeout={220}>
                            <div className="app-drawer__submenu">
                                <Link
                                    to={NETWORK_ROOM_AND_RATES}
                                    onClick={closeDrawer}
                                    className={`app-drawer__subitem${isActive(NETWORK_ROOM_AND_RATES) ? ' is-active' : ''}`}
                                >
                                    { t('enw-room_and_rate-title') }
                                </Link>
                                <Link
                                    to={NETWORK_ROOM_AND_RATES + "/new-rate"}
                                    onClick={closeDrawer}
                                    className={`app-drawer__subitem${isActive(NETWORK_ROOM_AND_RATES + "/new-rate") ? ' is-active' : ''}`}
                                >
                                    { t('btn-new_rate') }
                                </Link>
                                <Link
                                    to={NETWORK_ROOM_AND_RATES + "/edit-rate"}
                                    onClick={closeDrawer}
                                    className={`app-drawer__subitem${isActive(NETWORK_ROOM_AND_RATES + "/edit-rate") ? ' is-active' : ''}`}
                                >
                                    { t('btn-edit_rate') }
                                </Link>
                            </div>
                        </Collapse>
                        </>}

                        {/* Dil */}
                        <button
                            type="button"
                            className="app-drawer__item"
                            onClick={() => setLanguageOpen(!languageOpen)}
                            aria-expanded={languageOpen}
                        >
                            <i className="fal fa-globe" />
                            <span className="app-drawer__item-label">{ t('enw-input-language') }</span>
                            <i className={`fas fa-chevron-down app-drawer__chevron${languageOpen ? ' is-open' : ''}`} />
                        </button>
                        <Collapse in={languageOpen} timeout={220}>
                            <Language />
                        </Collapse>
                    </nav>

                    {/* Çıkış */}
                    {/* Extranetwork logosu (Charts tetikleyicisi): mobilde, footer'in
                        ust ayirici cizgisinin USTUNDE durur */}
                    {!isPropertySelectScreen && (
                        <Hidden lgUp>
                            <div className="app-drawer__charts">
                                <Charts />
                            </div>
                        </Hidden>
                    )}

                    <div className="app-drawer__footer">
                        <button type="button" className="app-drawer__logout" onClick={onClickLogout}>
                            <i className="fal fa-sign-out-alt" />
                            { t('btn-logout') }
                        </button>
                    </div>
                </div>
            </Drawer>
        </div>
    );
}
